import React, { Component } from "react";
import HeaderLabel from "./HeaderLabel";
import map from 'lodash/map';
import Wrp from '../../../../hoc/Wrp/Wrp';
class RadioButtons extends Component {
  render() {
    const  {
      id,
      meta,
      type,
      item,
      label,
      input,
      required,
      readOnly,
      generator,
      showError,
      defaultValue,
      validationForms
    } = this.props;

    const options = generator ? this.props.options : this.props.item.options;

    const _props = generator ? {
      ...input,
      disabled: readOnly,
    } : {}

    const isChecked = (id) => {
      return generator 
      ? defaultValue === id || input.value === id 
      : null
    }

    const change = (id) => {
      return generator
      ? () => input.onChange(id)
      : () => {}
    }
    console.log(this.props);
    // const attributes = {
		// 	placeholder: (item.isPlaceHolder==true)? item.helpText:'sss',
		// 	className: (item.required===true)? 'mandatory '+className:className,
    // 	readOnly:(item.access_mode=='VIEWONLY')?'readOnly':false,
    // checked:(item.selectedValue && item.selectedValue!==null)?item.selectedValue:item.default_value
    //   }
    return (
      <div className={"form-group row"} style={{display:(item.access_mode=='HIDDEN')?'none':''}}>
        {(item.sectionType!=='subform') ? 
          <HeaderLabel
          {...this.props.item}
          label={generator ? label : item.label}
          required={generator ? required : item.required}
          readOnly={readOnly}
        />
        :""}
        <div className="form-group">
        <div className="col-lg-9 col-md-9 col-sm-8" >
        <div className="selectgroup"> 
          {map(options, option => (
            <Wrp>
            {/* <div className="d-block" > */}
              {/* <input
                id={option.id}
                name={item.id}
                type={type}
                value={option.id}
                checked={isChecked(option.id)}
                onChange={change(option.id)}
              />
              <label className="form-label ml-2" htmlFor={option.id}>
                
              </label> */}
              <label className="selectgroup-item" data-toggle="popover" data-placement="top" data-content="can access all records" data-trigger="hover" data-original-title="" title=""><input type="radio" name="access1" className="selectgroup-input" value="GLOBAL" checked=""
              id={option.id}
              name={item.id}
              type={type}
              value={option.id}
              checked={isChecked(option.id)}
              onChange={change(option.id)}
              />
                <span className="selectgroup-button selectgroup-button-icon">{option.value}</span></label>
            </Wrp>
          ))}
          </div>
          </div>
        </div>
        {generator ? showError(meta.touched, meta.error, meta.warning) : ''}
      </div>
    );
  }
}

RadioButtons.defaultProps = {
  generator: false,
  disabled: false,
  type: "radio"
}

export default RadioButtons;